'use strict';

var React = require('react');

const getParentElements = (element, parents = []) => {
    const parent = element.parentElement;
    return parent ? getParentElements(parent, [...parents, parent]) : parents;
};
const useScrollListener = ({ elementRef, listener }) => {
    React.useEffect(() => {
        const element = elementRef.current;
        if (!element)
            return;
        const elements = [element, ...getParentElements(element)];
        elements.forEach(elementItem => elementItem.addEventListener('scroll', listener));
        return () => {
            elements.forEach(elementItem => elementItem.removeEventListener('scroll', listener));
        };
    }, [listener]);
};

exports.useScrollListener = useScrollListener;
//# sourceMappingURL=useScrollListener.js.map
